import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import GroupCategory from '../models/GroupCategory';

const initialState = {
    isFetching: false,
    isFetchingDetail: false,
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    totalPage: 0,
    orderBy: undefined,
    orderByDesc: false,
    groupCategories: [],
    groupCategoriesBackup: [],
    allGroupCategories: [],
    detail: {
        groupCategory: new GroupCategory(),
        // translate: new GroupCategory(),
        // language: undefined,
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.GROUP_CATEGORY_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.GROUP_CATEGORY_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false,
                groupCategories: action.groupCategories,
                groupCategoriesBackup: action.setBackup ? action.groupCategories : state.groupCategoriesBackup,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: action.totalCount && Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize)),
                languages: action.languages,
            };
        case Types.GROUP_CATEGORY_CREATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.GROUP_CATEGORY_CREATE_SUCCESS:
            return { ...state, isFetchingDetail: false };
        case Types.GROUP_CATEGORY_DELETE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.GROUP_CATEGORY_DELETE_SUCCESS:
            return { ...state, isFetchingDetail: false };
        case Types.GROUP_CATEGORY_UPDATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.GROUP_CATEGORY_UPDATE_SUCCESS:
            return { ...state, isFetchingDetail: false };
        case Types.GROUP_CATEGORY_GET_DETAIL_ACTION:
            return { ...state, isFetchingDetail: true, detail: initialState.detail };
        case Types.GROUP_CATEGORY_GET_DETAIL_SUCCESS:
            return { ...state, isFetchingDetail: false, detail: { ...state.detail, groupCategory: action.groupCategory, language: action.language } };
        // case Types.GROUP_CATEGORY_GET_TRANSLATE_ACTION:
        //     return { ...state, isFetchingTranslate: true };
        // case Types.GROUP_CATEGORY_GET_TRANSLATE_SUCCESS:
        //     return { ...state, isFetchingTranslate: false };
        case Types.GROUP_CATEGORY_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.GROUP_CATEGORY_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingDetail: false };
        case Types.GROUP_CATEGORY_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.GROUP_CATEGORY_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingDetail: false };
        case Types.GROUP_CATEGORY_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.GROUP_CATEGORY_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingDetail: false };
        case Types.GROUP_CATEGORY_LIST_ALL_ACTION:
            return { ...state, isFetching: true };
        case Types.GROUP_CATEGORY_LIST_ALL_SUCCESS:
            return { ...state, isFetching: false, allGroupCategories: action.allGroupCategories, };
        case Types.GROUP_CATEGORY_FAIL:
            return { ...state, isFetching: false, isFetchingDetail: false, };
        default:
            return state;
    }
}
